/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/10
 */
import config from 'crm/config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    currentTree: {
        url: `${authApi}/api/departments/tree/current`,
        type: 'GET',
    },
    departments: {
        url: `${authApi}/api/departments`,
        type: 'GET',
    },
}
